import { topicCollections } from '@/mocks/homeData';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function TopicCollections() {
  return (
    <section id="topics" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="专题合集"
          title="按专题成片单，一次挑完一类片子"
          desc="与其一部部翻，不如按专题进入：选定方向后，整份片单都能顺着看下去。"
          actionLabel="订阅专题更新"
        />

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {topicCollections.map((topic) => (
            <article
              key={topic.id}
              className="group overflow-hidden rounded-xl border border-background-200 bg-background-50 transition hover:border-primary-300"
            >
              <div className="h-44 w-full overflow-hidden bg-background-100">
                <img
                  src={topic.image}
                  alt={`${topic.title}主题图`}
                  title={`${topic.title}片单合集`}
                  className="h-44 w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{topic.title}</h3>
                  <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-800">
                    共 {topic.count} 部
                  </span>
                </div>
                <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{topic.desc}</p>
                <a href="#subscribe" className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-700 cursor-pointer">
                  进入专题
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-base"></i>
                  </span>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}